"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.topLevelStacks = void 0;
const serviceDefinition_1 = require("./serviceDefinition");
const types_1 = require("./types");
/**
 * The `stackName` must equal that in AWS CD or the deploy script will exit because the check on deploy status will fail (having the wrong name)
 * At some future time this `topLevelStack` will be combined with the stacks in `serviceDefiition`
 */
const topLevelStacks = () => {
    const { region, accountId, projectCode, stage } = process.env;
    return {
        AthenaGlue: {
            friendlyName: 'AthenaGlue',
            stackName: `${projectCode}-${stage}-athena-glue-Stack`,
            root: './BI/AthenaGlue',
            type: types_1.Deploy.CDK,
            substacks: {},
            /** at 2025 09, this post deploy step will run all ETL jobs including on populated largeObjects. It is suppressed to avoid cost */
            // postDeploy: `cd ../BI/AthenaGlue; ./initialize.sh; echo $(pwd); cd ../../Deploy;`
            /** at 2025 11, amended to preserve script loading to s3 */
            /** at 2025 12, suppress again as running against an empty s3 target populates an empty schema which won't update */
            // postDeploy: `cd ../BI/AthenaGlue; ./initialize.sh --no-run; echo $(pwd); cd ../../Deploy;`
            /** at 2026 01, added script to just upload (no run) */
            postDeploy: 'cd ../BI/AthenaGlue; ./upload.sh; echo $(pwd); cd ../../Deploy;'
        },
        AWS_LPNAS: {
            friendlyName: 'AWS_LPNAS',
            stackName: `${projectCode}-${stage}-aws-lpnas-Stack`,
            root: './BaseResources/AWS_LPNAS',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        EntityState: {
            friendlyName: 'EntityState',
            stackName: `${projectCode}-${stage}-EntityState`, //note not stack
            root: './Events/EntityState/Lambda',
            type: types_1.Deploy.CDK,
            substacks: {},
            preCDKScripts: [`aws cloudformation delete-stack --stack-name ${projectCode}-${stage}-DynanoDB-Stack`],
        },
        EntityStateImage: {
            friendlyName: 'EntityStateImage',
            stackName: `${projectCode}-${stage}-EntityStateImage-Stack`, //note not stack
            root: './Events/EntityState/ContainerImage',
            type: types_1.Deploy.CDK,
            substacks: {},
            preCDKScripts: ['tsc -b -v; ts-node ./esbuilder.ts;'],
        },
        CloudWatchAlerts: {
            friendlyName: 'CloudWatchAlerts',
            stackName: `${projectCode}-${stage}-CloudWatchAlerts-Stack`,
            root: './Alerts/CloudwatchAlerts',
            type: types_1.Deploy.CDK,
            build: 'cd ../../aws-services; ts-node ./outputCurrentLambdaConfigs.ts',
            substacks: {},
        },
        CognitoSetUp: {
            friendlyName: 'CognitoSetUp',
            stackName: `${projectCode}-cognito-stack-${stage}`, // note historical non-compliant order
            root: './Identity/cognito',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        ConsumerDataAPI: {
            friendlyName: 'ConsumerDataAPI',
            //i3012-dev-consumer-data-Stack
            stackName: `${projectCode}-${stage}-consumer-data-Stack`,
            root: './ConsumerData/API',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        ConsumerDataIO: {
            friendlyName: 'ConsumerDataIO',
            stackName: `${projectCode}-${stage}-ConsumerDataIO-Stack`,
            root: './ConsumerData/IO',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        DataAggregation: {
            friendlyName: 'DataAggregation',
            stackName: `${projectCode}-${stage}-DataAggregation-Stack`,
            root: './Events/DataAggregation',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        DataLifecycleProcess: {
            friendlyName: 'DataLifecycleProcess',
            stackName: `${projectCode}-${stage}-DataLifecycle-Stack`,
            root: './DataLifecycle',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        DeviceControl: {
            friendlyName: 'DeviceControl',
            stackName: `${projectCode}-${stage}-DeviceControl-Stack`,
            root: './NetworkSystem/DeviceControl',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        DeviceControlAPI: {
            friendlyName: 'DeviceControlAPI',
            stackName: `${projectCode}-${stage}-DeviceControlAPI-Stack`,
            root: './NetworkSystem/DeviceControlAPI',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        DeviceControlArbitration: {
            friendlyName: 'DeviceControlArbitration',
            stackName: `${projectCode}-${stage}-DeviceControlArbitration-Stack`,
            root: './NetworkSystem/DeviceControlArbitration',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        FanOut: {
            friendlyName: 'FanOut',
            stackName: `${projectCode}-${stage}-FanOut-Stack`,
            root: './Events/FanOut/Lamdba',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        FanOutImage: {
            friendlyName: 'FanOutImage',
            stackName: `${projectCode}-${stage}-FanOutImage-Stack`,
            root: './Events/FanOut/ContainerImage',
            type: types_1.Deploy.CDK,
            substacks: {},
            preCDKScripts: ['tsc -b -v; ts-node ./esbuilder.ts;'],
        },
        ExternalDNSandCloudfront: {
            friendlyName: 'ExternalDNSandCloudfront',
            stackName: `${projectCode}-${stage}-ExternalDNSandCloudfront`,
            root: './BaseResources/ExternalDnsPlusCloudfrontForS3',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        EFS: {
            friendlyName: 'EFS',
            stackName: `${serviceDefinition_1.serviceDefinition.IOTV_Stack.EFS.name}-Stack`,
            root: './BaseResources/EFS/EFS_FS1',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        HotColdLambda: {
            friendlyName: 'HotColdLambda',
            stackName: `${projectCode}-${stage}-HotColdLambda-Stack`,
            root: './Wideawake/HotColdLambda',
            type: types_1.Deploy.CDK,
            substacks: {},
            noCompile: true,
        },
        IAM: {
            friendlyName: 'IAM',
            stackName: `${projectCode}-${stage}-IAM-Stack`,
            root: './BaseResources/IAM',
            type: types_1.Deploy.CDK,
            substacks: {},
            noCompile: true,
        },
        IoTCoreSetUp: {
            friendlyName: 'IoTCoreSetUp',
            stackName: `${projectCode}-${stage}-iot-core-stack`,
            root: './BaseResources/iot',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        Kinesis: {
            friendlyName: 'Kinesis',
            stackName: `${projectCode}-${stage}-Kinesis-Stack`,
            root: './BaseResources/Kinesis',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        LambdaLayer: {
            friendlyName: 'LambdaLayer',
            stackName: `${projectCode}-${stage}-DatastoreLayerStack`,
            root: './datastore-layer',
            build: `ts-node ./esbuilder.ts;`,
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        LoggerLambda: {
            friendlyName: 'LoggerLambda',
            stackName: `${projectCode}-${stage}-LoggerLambda-Stack`,
            root: './BaseResources/Logger',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        MainTableSetUp: {
            friendlyName: 'MainTableSetUp',
            stackName: `${projectCode}-${stage}-main-table-stack`,
            root: './Database/MainDynamoDBTable',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        NotificationsSystem: {
            friendlyName: 'NotificationsSystem',
            stackName: `${projectCode}-${stage}-Notifications-Stack`,
            root: './Notifications/SubscriberNotifier',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        NetworkAPI: {
            friendlyName: 'NetworkAPI',
            stackName: `${projectCode}-${stage}-NetworkAPI-Stack`,
            root: './NetworkSystem/NetworkAPI',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        NetworkData: {
            friendlyName: 'NetworkData',
            stackName: `${projectCode}-${stage}-NetworkData-Stack`,
            root: './NetworkSystem/NetworkData/Lambda',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        NetworkDataImage: {
            friendlyName: 'NetworkDataImage',
            stackName: `${projectCode}-${stage}-NetworkDataImage-Stack`,
            root: './NetworkSystem/NetworkData/ContainerImage',
            type: types_1.Deploy.CDK,
            substacks: {},
            preCDKScripts: ['tsc -b -v; ts-node ./esbuilder.ts;'],
        },
        PlatformApplication: {
            friendlyName: 'PlatformApplication',
            stackName: `${projectCode}-${stage}-PlatformApplication-Stack`,
            root: './BaseResources/SNS/PlatformApplication',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        QuickSuite: {
            friendlyName: 'QuickSuite',
            stackName: `${projectCode}-${stage}-QuickSuite-Stack`,
            root: './BI/QuickSuite',
            type: types_1.Deploy.CDK,
            substacks: {},
            /** at 2025 09, this post deploy step will run all ETL jobs including on populated largeObjects. It is suppressed to avoid cost */
            // postDeploy: `cd ../BI/AthenaGlue; ./initialize.sh; echo $(pwd); cd ../../Deploy;`
        },
        Route53: {
            friendlyName: 'Route53',
            stackName: `${projectCode}-${stage}-Route53-Stack`,
            root: './BaseResources/Route53',
            type: types_1.Deploy.CDK,
            substacks: {},
            noCompile: true,
            preCDKScripts: [
                `
          # checks if envronment has legacy
          cdkPath=$(pwd)
          fnPath='../../Utilities/src/Environment/State'
          cd $fnPath
          hasExport=$(ts-node ./hasCloudformationExport.ts --exportName=${projectCode}-${stage}-Route53-Stack-regCertArn)
          cd $cdkPath
          export HAS_CFN_CERT_EXPORT=$hasExport
          echo HAS LEGACY CFN CERT: $HAS_CFN_CERT_EXPORT
        `,
            ],
        },
        S3: {
            friendlyName: 'S3',
            stackName: `${projectCode}-${stage}-S3-Stack`,
            root: './BaseResources/S3',
            type: types_1.Deploy.CDK,
            substacks: {},
            noCompile: true,
        },
        ScheduledReports: {
            friendlyName: 'ScheduledReports',
            stackName: `${projectCode}-${stage}-ScheduledReports-Stack`,
            root: './ScheduledReports',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        SES: {
            friendlyName: 'SES',
            stackName: `${projectCode}-${stage}-SES-Stack`,
            root: './BaseResources/SES',
            type: types_1.Deploy.CDK,
            substacks: {},
            noCompile: true,
        },
        SQS: {
            friendlyName: 'SQS',
            stackName: `${projectCode}-${stage}-SQS-Stack`,
            root: './BaseResources/SQS',
            type: types_1.Deploy.CDK,
            substacks: {},
            noCompile: true,
        },
        SQSDeadLetters: {
            friendlyName: 'SQSDeadLetters',
            stackName: `${projectCode}-${stage}-SQSDeadLetters`,
            root: './BaseResources/SQSDeadLetters',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        SystemAlerts: {
            friendlyName: 'SystemAlerts',
            stackName: `${projectCode}-${stage}-Alerts-Stack`,
            root: './Alerts/SystemAlerts',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        SystemManagementAPI: {
            friendlyName: 'SystemManagementAPI',
            stackName: `${projectCode}-${stage}-SystemManagementAPI-Stack`,
            root: './SystemManagement/API',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        SystemSelfCheck: {
            friendlyName: 'SystemSelfCheck',
            stackName: `${projectCode}-${stage}-SystemSelfCheck-Stack`,
            root: './Events/SystemSelfCheck',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        Timestream: {
            friendlyName: 'Timestream',
            stackName: `${projectCode}-${stage}-Timestream-Stack`,
            root: './BaseResources/Timestream',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        ThingAlerts: {
            friendlyName: 'ThingAlerts',
            stackName: `${projectCode}-${stage}-ThingAlerts-Stack`,
            root: './Alerts/ThingAlerts/Lambda',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        UserAssetsS3Bucket: {
            friendlyName: 'UserAssetsS3Bucket',
            stackName: `${projectCode}-${stage}-userblobs-${stage}`,
            root: './BaseResources/WebsiteBuckets/UserBlobs',
            type: types_1.Deploy.CDK,
            substacks: {},
            noCompile: true,
        },
        VPC: {
            friendlyName: 'VPC',
            stackName: `${projectCode}-${stage}-VPC-Stack`,
            root: './BaseResources/VPC',
            type: types_1.Deploy.CDK,
            substacks: {},
        },
        WebsiteS3Buckets: {
            friendlyName: 'WebsiteS3Buckets',
            stackName: `${projectCode}-website-bucket-stack-${stage}`,
            root: './BaseResources/WebsiteBuckets/website-buckets',
            type: types_1.Deploy.CDK,
            substacks: {},
            noCompile: true,
        },
        Wideawake: {
            friendlyName: 'Wideawake',
            stackName: `${projectCode}-${stage}-Wideawake-Stack`,
            root: './Wideawake/WideawakeCluster',
            type: types_1.Deploy.CDK,
            // build: `
            //   echo Requesting Wideawake dumps data to s3 before task replacement;\
            //   echo \`ts-node ../../Deploy/src/deployment/dumpWideawakeDataToS3.ts\`;
            //   echo Deploying Wideawake...
            // `,
            substacks: {
                NetworkDataStack: 'NetworkDataStack',
                FanOutStack: 'FanOutStack',
                WideawakeStack: 'WideawakeStack',
                WideawakeClusterStack: 'WideawakeClusterStack',
                RedisStack: 'RedisStack',
                EntityStateStack: 'EntityStateStack',
            },
        },
        WideawakeService: {
            friendlyName: 'WideawakeService',
            stackName: `${projectCode}-${stage}-WideawakeService-Stack`,
            root: './Wideawake/WideawakeService',
            type: types_1.Deploy.CDK,
            build: 'echo Building WideawakeService; yarn build;',
            substacks: {},
            preCDKScripts: ['tsc -b -v; ts-node ./esbuilder.ts;'],
        },
    };
};
exports.topLevelStacks = topLevelStacks;
